import { apim } from "./auth.service";
import axios from "axios";

const asrApi = process.env.REACT_APP_APIM_HOST;

const header = {
  "Ocp-Apim-Subscription-Key": process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
};

let cancelToken: any;
const asrListInitial = async () => {
  cancelPreviousRequest()
  try {
    return (
      await apim({
        url: `${asrApi}/asr/fetch`,
        method: "GET",
        headers: header,
        cancelToken: cancelToken.token
      })
    ).data;
  } catch (err: any) {
    return err?.response;
  }
};

const asrList = async (data: any) => {
  cancelPreviousRequest()
  try {
    return (
      await apim({
        url: `${asrApi}/asr/fetch`,
        method: "POST",
        data: data,
        headers: header,
        cancelToken: cancelToken.token
      })
    ).data;
  } catch (err: any) {
    return err?.response;
  }
};

const asrConfig = async () => {
  cancelPreviousRequest()
  try {
    return (
      await apim({
        url: `${asrApi}/asr/data/filter`,
        method: "GET",
        headers: header,
        cancelToken: cancelToken.token
      })
    ).data;
  } catch (err: any) {
    return err?.response;
  }
};

const cancelPreviousRequest = () => {
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel('aborted')
  }
  cancelToken = axios.CancelToken.source()
}

export { asrList, asrConfig, asrListInitial };
